import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { alertError, alertSuccess } from "../../../../_utils/alerts";
import { findAllAccessRolByRol, updateAccessRol } from "../../../../_services/access_rol.service";
import { findAllAccess } from "../../../../_services/access.service";

export default function AccessModal({ rol }) {
    const [show, setShow] = useState(false);
    const [ accessList, setAccessList ] = useState([]);
    const [ access, setAccess ] = useState([]);
  
    const handleClose = () => setShow(false);
    const handleShow = () => {
        findAllAccessRolByRol(rol)
        .then(json => {
            setAccess(json.list);
            findAllAccess()
            .then(json => {
                setAccessList(json.list);
            })
            .catch(err => {
                alertError(err.message);
            });
        })
        .catch(err => {
            alertError(err.message);
        });
        setShow(true);
    };

    const changeActions = (checked, actionCod) => {
        let newAccess = [...access];
        if(checked){
            newAccess.push(actionCod);
        } else {
            let index = newAccess.indexOf(actionCod);
            if(index !== -1) newAccess.splice(index, 1);
        }
        setAccess(newAccess);
    }

    const update = () => {
        updateAccessRol({
            rol: rol,
            accesses: access,
        })
        .then(json => {
            alertSuccess("Actualizado");
        })
        .catch(err => {
            alertError(err.message);
        });
    }
  
    return (
        <>
            <Button style={{ margin: '0 5px' }} variant="warning" size="sm" onClick={handleShow}>
                Accesos
            </Button>
    
            <Modal size="lg" show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Accesos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {
                    accessList.map( (ac, key) => (
                        <div key={`check_action_${key}`} className="flex-row" >
                            <input
                                style={{ marginRight: '10px' }}
                                id={`check_${key}`} 
                                type="checkbox"
                                checked = { access.some( a => a === ac.cod ) }
                                onChange={(e) => {
                                    changeActions(e.target.checked, ac.cod);
                                }}
                            />
                            <label style={{ fontSize: '0.95em' }} htmlFor={`check_${key}`}>{ac.name}</label>
                        </div>
                    ))
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
                <Button variant="success" onClick={update}>
                    Actualizar
                </Button>
            </Modal.Footer>
            </Modal>
        </>
    );
}